import florencePic from "@/public/images/artists/florence.png";
import { Artist } from "@/types/types";

export const florence = {
  id: "295",
  name: "Florence",
  image: florencePic,
  description: `Florence has a clean, bright voice with a smooth tone, a slight bite, and a confident, upfront feel.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fflorence-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Female",
    tags: {
      primary: ["Unprocessed", "Dance", "Belting", "RnB"],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "High",
        high: "High",
      },
      specific: {
        low: 56,
        high: 72,
      },
      sweetSpot: 63,
    },
  },
} as const satisfies Artist;
